import EmptyState from "@/components/EmptyState";
import usePageTitle from "@/hooks/usePageTitle";
import CommissionTabLayout from "../_CommissionTabLayout";
import { useRequireCommissionPlatform } from "../useCommissionPlatformGate";

export default function CommissionFundingPage() {
  usePageTitle("/billing/finance/commission/funding", "Funding");
  useRequireCommissionPlatform();

  return (
    <CommissionTabLayout>
      <EmptyState title="Coming soon" caption="Funding workflows are not available yet." iconName="paid" />
    </CommissionTabLayout>
  );
}
